module.exports = __webpack_public_path__ + "r-v3/img/download.e955e23b.svg";